import { authHeader, multipartHeader } from "./auth-header";
import axiosInstance from "./axiosInstance";

const getAll = (params) => {
  return axiosInstance.Auth.get(process.env.REACT_APP_API_URL + "user/list", {
    headers: authHeader(),
    data: {},
    params: {
      ...params,
      usersId: params.userIds ? params.userIds.join(",") : [], // Convert array to a comma-separated string
    },
    withCredentials: true,
  });
};

const getReported = (params) => {
  return axiosInstance.Auth.get(
    process.env.REACT_APP_API_URL + "user/report/all",
    {
      headers: authHeader(),
      data: {},
      params: params,
      withCredentials: true,
    }
  );
};

const getActiveList = (params, id) => {
  return axiosInstance.Auth.get(
    process.env.REACT_APP_API_URL + `user/ad/favorite/${id}`,
    {
      headers: authHeader(),
      data: {},
      params: params,
      withCredentials: true,
    }
  );
};

const getReportedView = (id) => {
  return axiosInstance.Auth.get(
    process.env.REACT_APP_API_URL + `user/report/${id}`,
    {
      headers: authHeader(),
      data: {},
      withCredentials: true,
    }
  );
};

const get = (id) => {
  return axiosInstance.Auth.get(
    process.env.REACT_APP_API_URL + `user/view/${id}`,
    {
      headers: authHeader(),
      data: {},
      withCredentials: true,
    }
  );
};

const create = (data) => {
  return axiosInstance.Auth.post(
    process.env.REACT_APP_API_URL + `user/create`,
    data,
    {
      headers: multipartHeader(),
      withCredentials: true,
    }
  );
};

const update = (id, data) => {
  return axiosInstance.Auth.put(
    process.env.REACT_APP_API_URL + `user/update/${id}`,
    data,
    {
      headers: multipartHeader(),
      withCredentials: true,
    }
  );
};

const updateStatus = (id, data) => {
  return axiosInstance.Auth.put(
    process.env.REACT_APP_API_URL + `user/updateStatus/${id}`,
    data,
    {
      headers: authHeader(),
      withCredentials: true,
    }
  );
};

const updateKYC = (id, data) => {
  return axiosInstance.Auth.get(
    process.env.REACT_APP_API_URL + `user/directVerification/${id}`,
    data,
    {
      headers: authHeader(),
      withCredentials: true,
    }
  );
};

const deleteUser = (id, data) => {
  return axiosInstance.Auth.delete(
    process.env.REACT_APP_API_URL + `user/delete/${id}`,
    {
      headers: authHeader(),
      data: data,
      withCredentials: true,
    }
  );
};

const restore = (id, data) => {
  return axiosInstance.Auth.post(
    process.env.REACT_APP_API_URL + `user/restore/${id}`,
    data,
    {
      headers: authHeader(),
      withCredentials: true,
    }
  );
};

const addusersuperadmin = (data) => {
  return axiosInstance.Auth.post(
    process.env.REACT_APP_API_URL + `user/register/backEnd`,
    data,
    {
      headers: multipartHeader(),
      withCredentials: true,
    }
  );
};

const uploadUserImage = (data) => {
  return axiosInstance.Auth.post(
    process.env.REACT_APP_API_URL + `user/upload/profileImage`,
    data,
    {
      headers: multipartHeader(),
      withCredentials: true,
    }
  );
};

const updateCoin = (data) => {
  return axiosInstance.Auth.put(
    process.env.REACT_APP_API_URL + `wallet/update/coin`,
    data,
    {
      headers: authHeader(),
      withCredentials: true,
    }
  );
};

const updateBoost = (id, data) => {
  return axiosInstance.Auth.put(
    process.env.REACT_APP_API_URL + `boosterPlan/addBoost/${id}`,
    data,
    {
      headers: authHeader(),
      withCredentials: true,
    }
  );
};

const getUserName = (data) => {
  return axiosInstance.Auth.post(
    process.env.REACT_APP_API_URL + `user/check/username`,
    data,
    {
      headers: authHeader(),
      withCredentials: true,
    }
  );
};

const getUnverifiedList = (params) => {
  return axiosInstance.Auth.get(
    process.env.REACT_APP_API_URL + `user/list/not-verified`,
    {
      headers: authHeader(),
      data: {},
      params: params,
      withCredentials: true,
    }
  );
};

const getUnverifiedUserDetails = (id) => {
  return axiosInstance.Auth.get(
    process.env.REACT_APP_API_URL + `user/id-details/${id}`,
    {
      headers: authHeader(),
      data: {},
      withCredentials: true,
    }
  );
};

// user/verifyDocument/:publicId
const updateKYCStatus = (data) => {
  return axiosInstance.Auth.post(
    process.env.REACT_APP_API_URL + `user/verifyDocument/${data?.id}`,
    data,
    {
      headers: authHeader(),
      withCredentials: true,
    }
  );
};

const getUserRejectionCount = (data) => {
  return axiosInstance.Auth.get(
    process.env.REACT_APP_API_URL + `user/kyc/rejections/${data}`,
    {
      headers: authHeader(),
      withCredentials: true,
    }
  );
};
export default {
  getAll,
  getReported,
  getActiveList,
  get,
  getReportedView,
  create,
  update,
  updateStatus,
  deleteUser,
  restore,
  addusersuperadmin,
  uploadUserImage,
  updateKYC,
  updateCoin,
  updateBoost,
  getUserName,
  getUnverifiedList,
  getUnverifiedUserDetails,
  updateKYCStatus,
  getUserRejectionCount,
};
